import DOMAINS from './Domains'
import APP from './app'

export {
  DOMAINS,
  APP,
}
